import React from 'react';
function MemberProfile({img="https://www.strasys.uk/wp-content/uploads/2022/02/Depositphotos_484354208_S.jpg", name, designation}) {
  return (
    <>
      <div className="w-72 relative h-80 overflow-hidden group mx-auto dark:bg-black  bg-white dark:border-0 border rounded-md dark:text-white text-black flex flex-col">
        <div className="w-full h-full ">
          <img
            src={img}
            alt={designation}
            className="h-full w-full  scale-105 group-hover:scale-100 object-cover transition-all duration-300 rounded-md"
          />
        </div>
        
        <article className="p-2 w-full h-[20%] flex flex-col justify-end  overflow-hidden  absolute bottom-0 rounded-b-md bg-gradient-to-t from-theme  opacity-100 group-hover:opacity-0 group-hover:-bottom-4 transition-all duration-300">
          <h1 className="md:text-2xl font-semibold">{name}</h1>
          <p className="sm:text-base text-sm">{designation}</p>
        </article>
      </div>
    </>
  );
}
export default MemberProfile;
